export default "__VITE_ASSET__DuBscCLV__"